import React, {useEffect, useRef, useState} from 'react';
import UserLogList from './UserLogList.js';
import PopupSearch from './PopupSearch.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

const SEARCH_DEBOUNCE_MS = 500;

// Popup s user logy konkrétního uživatele. Filtrování na uživatele je řešené
// předvyplněním jeho e-mailu do hledání – seznam je pak stejný jako v /userlog
// (sdílená komponenta UserLogList) a hledání jde libovolně přepsat.
export default function UserLogsPopup({showLogs, closeLogs, user, listRows}) {
	const popupAnimationMs = 300;
	const [searchInput, setSearchInput] = useState('');
	const [search, setSearch] = useState(null);
	const {shouldRender, isClosing} = usePopupAnimation(showLogs, popupAnimationMs);

	const debounceRef = useRef(null);

	useEffect(() => {
		return () => {
			if (debounceRef.current) {
				clearTimeout(debounceRef.current);
			}
		};
	}, []);

	// Otevření → hledání předvyplníme e-mailem uživatele. Dokud není nastavené
	// (search === null), seznam nerenderujeme, aby se nenačetl zbytečně bez filtru.
	useEffect(() => {
		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
			debounceRef.current = null;
		}

		if (showLogs) {
			setSearchInput(user?.EMAIL || '');
			setSearch(user?.EMAIL || '');
		} else {
			setSearchInput('');
			setSearch(null);
		}
	}, [showLogs, user?.EMAIL]);

	const onChangeSearch = (value) => {
		setSearchInput(value);

		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
		}

		debounceRef.current = setTimeout(() => {
			setSearch(value);
			debounceRef.current = null;
		}, SEARCH_DEBOUNCE_MS);
	};

	const userName = user?.NAME || `${user?.LASTNAME || ''} ${user?.FIRSTNAME || ''}`.trim();

	return (
		<>
			{shouldRender ? (
				<div className={`popup user-logs-popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content user-logs-popup__content${isClosing ? ' popup_content--closing' : ''}`}>
						<div className="popup_content_in_head">
							<div className="popup_content_in_head_in">Logy{userName !== '' ? ` – ${userName}` : ''}</div>
							<img
								alt=""
								className="popup_content_in_head_in-close"
								onClick={() => {
									closeLogs();
								}}
							/>
						</div>
						<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar user-logs-popup__body">
							<div className="popup_content_in_body_in user-logs-popup__body-in">
								<div className="user-logs-popup__search-wrap">
									<PopupSearch searchValue={searchInput} onChangeSearch={onChangeSearch} placeholder="Vyhledat v lozích" className="user-logs-popup__search" />
								</div>
								{search !== null ? <UserLogList searchValue={search} listRows={listRows} variant="popup" /> : null}
							</div>
						</div>
						<div className="popup_content_in_foot">
							<div className="popup_content_in_foot_in user-logs-popup__foot">
								<button
									type="button"
									className="button"
									onClick={() => {
										closeLogs();
									}}
								>
									Zpět
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
